import { MediaQueryStyleSheet } from 'react-native-responsive';
import { PALETTE } from "../../../../src/constants";

export default MediaQueryStyleSheet.create({
  marketValueLabel: {
    fontSize: 16,
  },
  decimalStyle: {
    fontSize: '1.78vw',
    color: PALETTE.secondaryActive
  },
  marketValueText: {
    color: PALETTE.secondaryActive,
    fontSize: '2.68vw',
  },
  currencyStyle: {
    fontSize: 18,
  }
});
